<script>import Renderer from "./Renderer.svelte";
export let children;
export let type = void 0;
export let position = void 0;
export let __index = void 0;
type && position && __index;
</script>

{#each children as child, __index}
	<Renderer astNode={child} {__index} />
{/each}
